export const TAGS = {
  lci3Reports: 'LCI3 Reports',
  campaigns: 'Campaigns',
} as const;
